import React, { Component } from 'react';
import { connect } from 'react-redux';

import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import { getCustomer } from 'services/Rest';
import {
  getHasErrorCustomer,
  getHasReceivedCustomer,
  getHasRequestedCustomer
} from 'state/requests/RequestStatusSelectors';

import {
  getCustomerServiceType,
  getCustomerServiceLevel
} from 'state/customer/CustomerSelectors';

const ServiceBenefitsDataProvider = (WrappedComponent) => {
  class ServiceBenefitsData extends Component {
    state = {
      isLoading: false
    };

    componentDidMount() {
      this.fetchDataWhenAvailable();
    }

    componentDidUpdate(prevProps) {
      const { hasReceivedCustomer } = this.props;

      const { isLoading } = this.state;

      const requestHasResolved =
        !prevProps.hasRequestedCustomer && hasReceivedCustomer;

      if (isLoading && requestHasResolved) {
        this.setState({ isLoading: false });
      }
    }

    fetchDataWhenAvailable = () => {
      const { requestStatus } = this.props;
      this.setState({ isLoading: true });

      if (
        !requestStatus.customer === REQUEST_STATES.requested &&
        !requestStatus.customer === REQUEST_STATES.received
      ) {
        getCustomer();
      }
    };

    render() {
      const { serviceLevel, serviceType } = this.props;

      const { isLoading, hasErrorCustomer } = this.state;

      const data = {
        serviceLevel,
        serviceType
      };

      return (
        <WrappedComponent
          data={data}
          isLoading={isLoading}
          hasError={hasErrorCustomer}
        />
      );
    }
  }
  const mapStateToProps = (state) => ({
    serviceLevel: getCustomerServiceLevel(state),
    serviceType: getCustomerServiceType(state),
    requestStatus: getRequestStatus(state),
    hasRequestedCustomer: getHasRequestedCustomer(state),
    hasReceivedCustomer: getHasReceivedCustomer(state),
    hasErrorCustomer: getHasErrorCustomer(state)
  });

  return connect(mapStateToProps)(ServiceBenefitsData);
};

export default ServiceBenefitsDataProvider;
